import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, Tooltip, Legend, ArcElement } from 'chart.js';
import styled from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledPieChartWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n"])), function (props) {
  return props.width;
});
ChartJS.register(ArcElement, Tooltip, Legend);
var options = {
  plugins: {
    legend: {
      position: 'right',
      // Position the legend to the right
      align: 'center' // Align the legend labels parallel to the chart

    }
  }
};
var backgroundColors = ['#FF6384', '#36A2EB', '#FFCE56'];
export var PieChart = function PieChart(props) {
  var data = props.data,
      label = props.label,
      width = props.width; // Data for the chart

  var pieLabels = data.map(function (item) {
    return item.label;
  });
  var pieData = data.map(function (item) {
    return item.data;
  });
  var pieChartData = {
    labels: pieLabels,
    datasets: [{
      label: label,
      data: pieData,
      backgroundColor: backgroundColors
    }]
  };
  return /*#__PURE__*/_jsx(StyledPieChartWrapper, {
    width: width,
    children: /*#__PURE__*/_jsx(Pie, {
      data: pieChartData,
      options: options
    })
  });
};